<template>
  <div class="app-landing-main-container" v-if="showContent">
    <!-- HEADER -->
    <header class="landing-header">
      <img
        src="../../assets/img/logos/logo-hellobb-dark.svg"
        alt="Logo HelloBB"
        class="logo"
      />
    </header>

    <!-- CARRUSEL -->
    <div 
      class="landing-carousel-wrapper"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd"
    >
      <div class="landing-carousel-track" :style="trackStyle" :key="$i18n.locale">
        <div class="landing-app-slide" v-for="(slide, index) in slides" :key="index">
          <!-- TÍTULO -->
          <div class="slide-title-section">
            <div class="landing-app-title">{{ slide.title }}</div>
          </div>

          <!-- IMAGEN -->
          <div class="slide-image-section">
            <img :src="slide.image" :key="slide.image" alt="" class="imagen" />
          </div>
        </div>
      </div>
    </div>

    <!-- DOTS -->
    <div class="landing-dots">
      <span
        v-for="(slide, index) in slides"
        :key="'dot-' + index"
        class="dot"
        :class="{ active: currentIndex === index }"
        @click="goToSlide(index)"
      />
    </div>

    <!-- BOTONES -->
    <div class="landing-actions px-4">
      <button
        class="button button--primary button--block button--lg mb-3"
        @click="onRegister"
      >
        {{ $t("landingapp.signup") }}
      </button>
      <button
        class="button button--transparent button--block button--lg"
        @click="onLogin"
      >
        {{ $t("landingapp.login") }}
      </button>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      currentIndex: 0, // importante: empieza en el real 0 (índice 1)
      lang: "es",
      touchStartX: 0,
      touchDeltaX: 0,
      isSwiping: false,
      transitioning: false,
      autoplayInterval: null,
      slides: [],
      showContent: false,
    };
  },
  computed: {
    ...mapGetters({
      isApp: "isApp",
    }),
    trackStyle() {
      const offset = this.isSwiping ? this.touchDeltaX / window.innerWidth * 100 : 0;
      return {
        transform: `translateX(${(-this.currentIndex * 100) + offset}%)`,
        transition: this.transitioning ? 'transform 0.4s ease' : 'none',
      };
    },
  },
  methods: {
    onRegister() {
      window.location.href = "https://www.hellobb.net/signup";
    },
    onLogin() {
      window.location.href = "https://www.hellobb.net/login";
    },
    nextSlide() {
      if (this.currentSlide < this.slides.length - 1) this.currentSlide++;
    },
    prevSlide() {
      if (this.currentSlide > 0) this.currentSlide--;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    onTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchDeltaX = 0;
      this.isSwiping = true;
      this.transitioning = false;
    },
    onTouchMove(event) {
      const currentX = event.touches[0].clientX;
      this.touchDeltaX = currentX - this.touchStartX;
    },
    onTouchEnd() {
      const threshold = 50;
      this.isSwiping = false;
      this.transitioning = true;

      if (this.touchDeltaX < -threshold && this.currentIndex < this.slides.length - 1) {
        this.currentIndex++;
      } else if (this.touchDeltaX > threshold && this.currentIndex > 0) {
        this.currentIndex--;
      }

      this.touchDeltaX = 0;

      // Esperamos a que termine la animación y corregimos si está en clon
      setTimeout(() => {
        this.transitioning = false;

        // if (this.currentIndex === 0) {
        //   this.currentIndex = this.slides.length;
        // } else if (this.currentIndex === this.slides.length + 1) {
        //   this.currentIndex = 1;
        // }
      }, 400);
    },
    handleSwipe() {
      const delta = this.touchStartX - this.touchEndX;
      const minSwipeDistance = 50; // píxeles mínimos para considerar swipe

      if (delta > minSwipeDistance && this.currentSlide < this.slides.length - 1) {
        this.currentSlide++;
      } else if (delta < -minSwipeDistance && this.currentSlide > 0) {
        this.currentSlide--;
      }
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        if (this.currentIndex < this.slides.length - 1) {
          this.transitioning = true;
          this.currentIndex++;
          setTimeout(() => {
            this.transitioning = false;
          }, 400);
        } else {
          // Al llegar al final, paramos autoplay
          this.stopAutoplay();
        }
      }, 5000);
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    },
  },
  beforeCreate() {
    if (typeof window === "undefined") return;
    let langUrl = new URLSearchParams(window.location.search).get("lang") || "es";
    console.log("langUrl", langUrl);
    if(langUrl == "fr") {
      this.lang = "fr-FR";
    } else if(langUrl == "it") {
      this.lang = "it-IT";
    }
    else {
      this.lang = "es";
    }
    this.$i18n.locale = this.lang;
  },
  mounted() {
    this.startAutoplay();
    this.slides = [
        {
          title: this.$t("landingapp.slide1"),
          image: this.$t("landingapp.logosImageUrl"),
        },
        {
          title: this.$t("landingapp.slide2"),
          image: this.$t("landingapp.piggybankImageUrl"),
        },
        {
          title: this.$t("landingapp.slide3"),
          image: "https://images.hellobb.net/web/app-slide-1.png?v=1",
        },
        {
          title: this.$t("landingapp.slidePrices"),
          image: this.$t("landingapp.pricesImageUrl"),
        },
        {
          title: this.$t("landingapp.slide4"),
          image: "https://images.hellobb.net/web/app-share.png?v=5",
        },
      ];
    this.showContent = true;
  },  
};
</script>

<style scoped>
.app-landing-main-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: white;
}

.landing-header {
  background-color: white;
  flex-shrink: 0;
  padding: .8125rem 0;
  padding-left: 1.2rem;
  box-shadow: 0 8px 16px rgba(30, 0, 40, 0.08) !important;
}

.logo {
  width: 90px;
}

/* CARRUSEL */
.landing-carousel-wrapper {
  position: relative;
  overflow: hidden;
  flex-grow: 1;
  display: flex;
}

.landing-carousel-track {
  display: flex;
  width: 100%;
}

.landing-app-slide {
  flex: 0 0 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* TÍTULO */
.slide-title-section {
  flex-shrink: 0;
  padding: 1rem;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.landing-app-title {
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.4;
  min-height: calc(1.5rem * 1.4 * 3);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* IMAGEN */
.slide-image-section {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding 1rem excep top (0) */
  padding: 0 1rem 1rem 1rem;
  background: #ffffff;
  min-height: 0; /* ← para que flexbox permita encoger el contenedor */
}

.imagen {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: contain;
}

/* DOTS */
.landing-dots {
  flex-shrink: 0;
  padding: 1rem 0;
  display: flex;
  justify-content: center;
  gap: 10px;
  background: white;
}

.dot {
  width: 10px;
  height: 10px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dot.active {
  background-color: #000;
}

/* BOTONES */
.landing-actions {
  flex-shrink: 0;
  background-color: white;
  padding: 1rem;
  box-shadow: 0 -8px 16px rgba(30, 0, 40, 0.08);
}

</style>
